export default __webpack_public_path__ + "static/media/google_cloud.1ccbfe3c.svg";